import LOL_abi from "../config/abi/LOL.json";
import LOLExchange_abi from "../config/abi/LOLExchange.json";
import LOLToken_abi from "../config/abi/LOLToken.json";
import LOLVesting_abi from "../config/abi/LOLVesting.json";
import { ContractsConfig } from "../types";

export const Contracts: ContractsConfig = {
    development: {
        LOL: {
            decimals: 18,
            chainId: 11155111,
            address: "0x67fc48DC9De724Dad662A94719F1aa4Bd75cF412",
            abi: LOL_abi.abi,
        },
        LOLToken: {
            decimals: 18,
            chainId: 11155111,
            address: "0xf9F7E32dE4c0717298f55a7eE2c124Ee33005f3c",
            abi: LOLToken_abi.abi,
        },
        LOLExchange: {
            decimals: 18,
            chainId: 11155111,
            address: "0x1EeAe880797C5887A2A9e08632A3030030334e05",
            abi: LOLExchange_abi.abi,
        },
        LOLVesting: {
            decimals: 18,
            chainId: 11155111,
            address: "0xd702d6B0ef45C00257241c21AD6E60c9F2fFeEAE",
            abi: LOLVesting_abi.abi,
        },
    },
    production: {
        LOL: {
            decimals: 18,
            chainId: 11155111,
            address: "0x67fc48DC9De724Dad662A94719F1aa4Bd75cF412",
            abi: LOL_abi.abi,
        },
        LOLToken: {
            decimals: 18,
            chainId: 11155111,
            address: "0xf9F7E32dE4c0717298f55a7eE2c124Ee33005f3c",
            abi: LOLToken_abi.abi,
        },
        LOLExchange: {
            decimals: 18,
            chainId: 11155111,
            address: "0x1EeAe880797C5887A2A9e08632A3030030334e05",
            abi: LOLExchange_abi.abi,
        },
        LOLVesting: {
            decimals: 18,
            chainId: 11155111,
            address: "0xd702d6B0ef45C00257241c21AD6E60c9F2fFeEAE",
            abi: LOLVesting_abi.abi,
        },
    }
};
